import type { SelectableObject } from '../three/selectableObject';
import { atom } from 'nanostores';

export const $selectedObjects = atom<SelectableObject[]>([]);

export function addSelectedObject(object: SelectableObject) {
  const current = $selectedObjects.get();
  if (current.includes(object)) {
    return;
  }

  $selectedObjects.set([...current, object]);
}

export function removeSelectedObject(object: SelectableObject) {
  $selectedObjects.set(
    $selectedObjects.get().filter(selectedObject => selectedObject !== object),
  );
}

export function deselectAll() {
  for (const object of [...$selectedObjects.get()]) {
    object.deselect();
  }
}
